import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import './App.css'

// Scale the whole UI down on small displays (index.css --ui-zoom). Keyed off
// the display's size (CSS px at 100% zoom, unaffected by browser zoom), not
// the viewport, so zooming the browser in or out always moves monotonically.
// Re-evaluated on resize, which also fires when the window changes display.
// Phones and tablets (touch, display under 1100px: the story viewer's
// handheld test, useHandheldLayout.ts) have their own layouts and stay 1:1.
const applyCompactUi = () => {
  const touch = (navigator.maxTouchPoints ?? 0) > 0
  const handheld = touch && window.screen.width <= 1100
  const compact = !handheld && (window.screen.width <= 1600 || window.screen.height <= 900)
  document.documentElement.classList.toggle('ui-compact', compact)
}
applyCompactUi()
window.addEventListener('resize', applyCompactUi)
import App from './App.tsx'
import { initSentry } from './sentry.ts'

initSentry()

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={<p>Something went wrong. Our team has been notified.</p>}>
    <App />
  </Sentry.ErrorBoundary>
)
